export const loadInfluencePopupScript = () => {
	const script = document.createElement("script");
	script.src = "https://widgets.influence.io/dist/popup/main.js";
	script.defer = true;

	script.onload = () => {
		if (window.influenceioPopupWidget) {
			setTimeout(() => window.influenceioPopupWidget(), 500);
		}
	};

	script.onerror = () => {
		console.error("Failed to load Influence.io script");
	};

	document.body.appendChild(script);

	return () => {
		if (script) document.body.removeChild(script);
	};
};
